import React, { useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';

import { MUTATIONS } from '../../../graphql';

import { 
  Button, Card, CardContent, CircularProgress, Container, TextField
} from '@material-ui/core';

import useLoginStyle from './login.style';
import { useSnackbarMutation } from '../../../hooks';
import { 
  setUserLoggedIn, useUserDispatch, useUserState 
} from "../../../context/UserContext";

import { logo } from '../../../assets';

function LoginPage(props: any) {
  const { history } = props;

  const { isAuthenticated } = useUserState();
  const dispatch = useUserDispatch();

  const classes = useLoginStyle();
  const [invokeLogin, { loading }] = useSnackbarMutation(
    MUTATIONS.LOGIN, {
      onCompleted: ({ login: user }) => {
        if (user) {
          setUserLoggedIn(dispatch, user.token, user.role, user.buildings);
          //history.push('/app');
        }
      }
    }
  );

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const formEnabled = useMemo(() => {
    return !loading;
  }, [loading]);

  const submitButtonEnabled = useMemo(() => {
    return username && password && formEnabled
  }, [username, password, formEnabled]);

  const onFormSubmit = (evt) => {
    evt.preventDefault();
    invokeLogin({
      variables: {
        username,
        password
      }
    });
  };

  if (isAuthenticated) {
    history.push('/app');
  }

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <Card className={classes.card}>
        <CardContent>
          <img className={classes.logo} alt="logo" src={logo} />
          <form className={classes.form} onSubmit={onFormSubmit} noValidate autoComplete="off">
            <TextField
              disabled={!formEnabled} 
              label="Username" 
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField 
              type="password"
              disabled={!formEnabled}
              label="Password" 
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button 
              type="submit"
              disabled={!submitButtonEnabled}
              className={classes.formSubmitButton}
              variant="contained" 
              color="primary"
            >
              {
                !loading ? 'Login' : <CircularProgress />
              }
            </Button>
          </form>
        </CardContent>
      </Card>
    </Container>
  )
}

export default withRouter(LoginPage);